// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3ebky","studyBtn":"styles_studyBtn__5-kjO"};